import axios from 'axios';

// Add request interceptor to include Authorization header from localStorage
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('jwt_token');
    if (token && token !== 'null' && token !== 'undefined') {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor to handle auth errors
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // If we get a 401, clear all auth state and redirect to login
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('jwt_token');
      localStorage.removeItem('user_info');
      window.location.href = '/login';
    }
    
    // If we get a 403 with CSRF error, show helpful message
    if (error.response && error.response.status === 403) {
      const detail = error.response.data?.detail || '';
      if (detail.includes('CSRF')) {
        console.error('CSRF token error - please refresh the page');
      }
    }
    
    return Promise.reject(error);
  }
);

export default axios;
